<template>
  <div class="documentos-cartoes">
    <div class="page-header">
      <h1 class="page-title">
        <i class="fas fa-file-pdf"></i>
        Importar Cartões Resposta Corrigidos
      </h1>
      <p class="page-subtitle">
        Envie em lote os PDFs de cartões resposta corrigidos para o sistema, vinculando pelo ID da inscrição no nome do arquivo.
      </p>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="form-grid">
          <div class="form-group">
            <label>Pasta local com PDFs *</label>
            <input
              ref="inputPasta"
              type="file"
              class="form-control"
              webkitdirectory
              multiple
              @change="onFolderChange"
            />
            <small class="form-text text-muted">
              Cada arquivo deve estar nomeado com o ID da inscrição, ex:
              <code>283.pdf</code>
            </small>
            <div v-if="arquivosSelecionados.length" class="mt-1 small text-muted">
              {{ arquivosSelecionados.length }} arquivo(s) selecionado(s).
            </div>
          </div>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label>Título padrão do documento</label>
            <input v-model="form.titulo" type="text" class="form-control" />
          </div>

          <div class="form-group">
            <label>Tipo do documento</label>
            <input v-model="form.tipo" type="text" class="form-control" />
          </div>
        </div>

        <div class="form-group">
          <label>Descrição padrão</label>
          <textarea v-model="form.descricao" class="form-control" rows="2"></textarea>
        </div>

        <div class="actions">
          <button
            class="btn btn-primary"
            :disabled="processing || !arquivosSelecionados.length"
            @click="processarCartoes"
          >
            <i :class="processing ? 'fas fa-spinner fa-spin' : 'fas fa-cloud-upload-alt'"></i>
            {{ processing ? 'Processando...' : 'Enviar cartões para o sistema' }}
          </button>
        </div>

        <div v-if="resultado" class="resultado mt-4">
          <div class="alert alert-success" v-if="resultado.processados > 0">
            <strong>{{ resultado.processados }}</strong> de {{ resultado.total_arquivos }}
            arquivo(s) processados com sucesso.
          </div>

          <div v-if="resultado.erros.length" class="alert alert-warning">
            <h4>
              <i class="fas fa-exclamation-triangle"></i>
              Arquivos com erro ({{ resultado.erros.length }})
            </h4>
            <ul>
              <li v-for="(erro, i) in resultado.erros" :key="i">
                <strong>{{ erro.arquivo }}</strong> - {{ erro.motivo }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'DocumentosCartoes',

  data() {
    return {
      processing: false,
      arquivosSelecionados: [],
      resultado: null,
      form: {
        tipo: 'cartao_resposta',
        titulo: 'Cartão Resposta',
        descricao: 'Relatório de nota do candidato.'
      }
    }
  },

  methods: {
    onFolderChange(event) {
      const files = Array.from(event.target.files || [])
      this.arquivosSelecionados = files.filter(
        f => f.name.toLowerCase().endsWith('.pdf')
      )
    },

    async processarCartoes() {
      this.processing = true
      this.resultado = {
        processados: 0,
        total_arquivos: this.arquivosSelecionados.length,
        erros: []
      }

      for (const file of this.arquivosSelecionados) {
        const formData = new FormData()

        formData.append('tipo', this.form.tipo)
        formData.append('titulo', this.form.titulo)
        formData.append('descricao', this.form.descricao)
        formData.append('arquivos[]', file)

        try {
          await axios.post(
            '/ps/documento-inscricao/admin/processar-cartoes-upload',
            formData
          )

          this.resultado.processados++
        } catch (error) {
          this.resultado.erros.push({
            arquivo: file.name,
            motivo:
              error.response?.data?.error ||
              error.response?.data?.message ||
              'Erro no envio'
          })
        }
      }

      this.processing = false

      if (this.resultado.processados > 0) {
        this.$sweet?.sweetSuccess?.('Processamento concluído.')
      } else {
        this.$sweet?.sweetError?.('Nenhum arquivo processado.')
      }
    }
  }
}
</script>


<style scoped>
.documentos-cartoes {
  max-width: 700px;
}

.btn-upload {
  margin-top: 10px;
  padding: 8px 14px;
  cursor: pointer;
}

.progress-wrapper {
  margin-top: 15px;
}

.progress-bar {
  width: 100%;
  height: 14px;
  background: #eee;
  border-radius: 4px;
  overflow: hidden;
}

.progress {
  height: 100%;
  background: #4caf50;
  transition: width 0.3s;
}

.errors {
  margin-top: 15px;
  color: #c62828;
}

.success {
  margin-top: 15px;
  color: #2e7d32;
}
</style>
